<div class="content">
    <div class="row items-push">
        <div class="col-sm-12 text-left">
            <ol class="breadcrumb push-10-t">
                <li><a [routerLink]="['/']">Inicio</a></li>
                <li><span class="link-effect">HIPOS</span></li>
                <li><span class="link-effect">Seguimiento</span></li>
            </ol>
        </div>
    </div>
  </div>
  <div class="content">
    <div class="block">
      <div class="block-header">
        <h3 class="block-title">Seguimiento HIPOS</h3>
    </div>
    <div class="block-content">
        <div class="form-horizontal">
            <div class="form-group">
              <label class="col-md-2 control-label">Compañía:</label>
              <div class="col-md-4">
                <mat-form-field appearance="outline">
                  <mat-label> Seleccione: </mat-label>
                  <mat-select matSelect [(ngModel)]="model.idCompania" [disabled]="listaCompanias.length == 1" (selectionChange)="companiaChanged()">
                    <mat-option *ngFor="let company of listaCompanias" [value]="company.idCompania">
                      {{ company.nombre }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
                <label class="col-md-2 control-label">Sede:</label>
                <div class="col-md-4">
                  <mat-form-field appearance="outline">
                    <mat-label>
                      Seleccione
                    </mat-label>
                    <mat-select matSelect [(ngModel)]="model.sedes" multiple>
                      <mat-option *ngFor="let item of listaSedes; index as i" [value]="item.idSede">{{ item.nombre }}</mat-option>
                    </mat-select>
                  </mat-form-field>   
                </div>
            </div>
          <div class="form-group">
            <label class="col-md-2 control-label">Año:</label>
            <div class="col-md-4">
              <mat-form-field appearance="outline">
                <mat-label>
                  Seleccione
                </mat-label>
                <mat-select matSelect [(ngModel)]="model.anios" multiple>
                  <mat-option *ngFor="let item of listaAnios; index as i;" [value]='item'>{{item}}</mat-option>
                </mat-select>
              </mat-form-field>   
            </div>   
            <label class="col-md-2 control-label">Fecha de Evento:</label>
            <div class="col-md-4">
              <mat-form-field appearance="outline">
                <mat-label>Fecha de Evento</mat-label>
                <mat-date-range-input [rangePicker]="picker" min="2021-01-02">
                  <input matStartDate placeholder="Desde" [(ngModel)]="model.fechaInicioEvento" >
                  <input matEndDate placeholder="Hasta" [(ngModel)]="model.fechaFinEvento" >
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker disabled="false" ></mat-date-range-picker>
              </mat-form-field>
            </div>             
        </div>
        <div class="form-group">
          <label class="col-md-2 control-label">Empresa:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>Empresa</mat-label>
              <input matInput type="text" placeholder="Empresa" name="empresa" [(ngModel)]="model.contratista" maxlength="40" />
            </mat-form-field>   
          </div>
            <label class="col-md-2 control-label">Proyecto:</label>
            <div class="col-md-4">
              <mat-form-field appearance="outline">
                <mat-label>
                  Proyecto
                </mat-label>
                <input matInput type="text" placeholder="Proyecto" name="Proyecto" [(ngModel)]="model.proyecto" maxlength="40">
              </mat-form-field>   
            </div>
      </div>
      <div class="form-group">    
        <label class="col-md-2 control-label">Tipo Regla:</label>
        <div class="col-md-10">
          <mat-form-field appearance="outline">
            <mat-label>
              Seleccione
            </mat-label>
            <mat-select matSelect [(ngModel)]="model.tiposregla" multiple>
                <mat-option *ngFor="let item of listaTipoRegla; index as i;" [value]='item.idTipoRegla'>{{item.nombre}}</mat-option>
            </mat-select>
          </mat-form-field>   
        </div>           
      </div>
      <div class="form-group">
        <label class="col-md-2 control-label">Categoría:</label>
        <div class="col-md-4">
          <mat-form-field appearance="outline">
            <mat-label>
              Seleccione
            </mat-label>
            <mat-select matSelect [(ngModel)]="model.categorias" multiple>
              <mat-option *ngFor="let item of listaCategorias; index as i;" [value]='item.idCategoriaHipo'>{{item.nombre}}</mat-option>
            </mat-select>
          </mat-form-field>   
        </div> 
        <label class="col-md-2 control-label">Tipo Accidente:</label>
        <div class="col-md-4">
          <mat-form-field appearance="outline">
            <mat-label>
              Seleccione
            </mat-label>
            <mat-select matSelect [(ngModel)]="model.tipoaccidente" multiple>
              <mat-option *ngFor="let item of listaTipoAccidente; index as i;" [value]='item.idTipoAccidente'>{{item.nombre}}</mat-option>
            </mat-select>
          </mat-form-field>   
        </div> 
    </div>
        </div>
      </div>

      <div class="block-content">
        <div class="form-horizontal">
          <div class="form-group">
            <div class="col-sm-6 text-left">
              <a class="btn btn-naranja" mat-raised-button [routerLink]="['/hipos', 'registrar']"><mat-icon>description</mat-icon> Nuevo HIPOS</a>
              <!-- [routerLink]="['/solicitudes-engie/registrar']" -->
              <a class="btn btn-celeste" mat-raised-button (click)="export()"><mat-icon>table_chart</mat-icon> Exportar</a>
            </div>
            <div class="col-sm-6 text-right">
              <a class="btn btn-cyan" mat-raised-button (click)="search()"><mat-icon>search</mat-icon> Buscar</a>
            </div>
        </div>
        </div>
        <div class="table-responsive">
            <table mat-table [dataSource]="listaHipos" class="table table-striped table-vcenter">
              <ng-container matColumnDef="compania">
                <th mat-header-cell *matHeaderCellDef>Compañía</th>
                <td mat-cell *matCellDef="let element" class="centre">{{ element.compania }}</td>
              </ng-container>

                <ng-container matColumnDef="empresa">
                  <th mat-header-cell *matHeaderCellDef>Empresa</th>
                  <td mat-cell *matCellDef="let element">{{ element.contratista }}</td>
                </ng-container>
            
                <ng-container matColumnDef="gbu">
                  <th mat-header-cell *matHeaderCellDef>GBU</th>
                  <td mat-cell *matCellDef="let element" class="centre">{{ element.gbu }}</td>
                </ng-container>
            
                <ng-container matColumnDef="sede">
                    <th mat-header-cell *matHeaderCellDef>Sede</th>
                    <td mat-cell *matCellDef="let element" class="centre">{{ element.sede }}</td>
                  </ng-container>

                <ng-container matColumnDef="proyecto">
                  <th mat-header-cell *matHeaderCellDef>Proyecto</th>
                  <td mat-cell *matCellDef="let element">{{ element.proyecto }}</td>
                </ng-container>
            
                <ng-container matColumnDef="categoria">
                  <th mat-header-cell *matHeaderCellDef>Categoría</th>
                  <td mat-cell *matCellDef="let element">{{ element.categoriaHipo }}</td>
                </ng-container>

                <ng-container matColumnDef="texto">
                    <th mat-header-cell *matHeaderCellDef>Texto Identificativo</th>
                    <td mat-cell *matCellDef="let element">{{ element.textoIdentificativo }}</td>
                  </ng-container>
                  
                <ng-container matColumnDef="tiporegla">
                    <th mat-header-cell *matHeaderCellDef>Tipo Regla</th>
                    <td mat-cell *matCellDef="let element" class="centre">{{ element.tipoRegla }}</td>
                  </ng-container>

                <ng-container matColumnDef="fechaevento">
                  <th mat-header-cell *matHeaderCellDef>Fecha Evento</th>
                  <td mat-cell *matCellDef="let element" class="centre">{{ element.fechaEvento | date:'dd/MM/yyyy' }}</td>
                </ng-container>

                <ng-container matColumnDef="tiempoperdido">
                  <th mat-header-cell *matHeaderCellDef>Tiempo Perdido</th>
                  <td mat-cell *matCellDef="let element" class="centre">
                    <span *ngIf="element.tiempoPerdido">SI - {{element.nroDiasPerdidos}} día(s) </span> 
                    <span *ngIf="!element.tiempoPerdido">NO</span> 
                  </td>
                </ng-container>

                <ng-container matColumnDef="tipoempleado">
                    <th mat-header-cell *matHeaderCellDef>Tipo Empleado</th>
                    <td mat-cell *matCellDef="let element" class="centre">{{ element.tipoEmpleado }}</td>
                  </ng-container>

                  <ng-container matColumnDef="tipoaccidente">
                    <th mat-header-cell *matHeaderCellDef>Tipo Accidente</th>
                    <td mat-cell *matCellDef="let element" class="centre">{{ element.tipoAccidente }}</td>
                  </ng-container>

                <ng-container matColumnDef="seguimiento">
                    <th mat-header-cell *matHeaderCellDef>Acciones Completadas</th>
                    <td mat-cell *matCellDef="let element" class="centre">{{ element.totalAccionesCerradas }} de {{ element.totalAcciones }} </td>
                  </ng-container>
            
                <ng-container matColumnDef="acciones">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element"> 
                      <a mat-icon-button color="primary" *ngIf="element.editable || esAdminSSO" aria-label="Editar" [routerLink]="['/hipos', element.idHipo]">
                        <!-- (click)="openDialog(element)" -->
                        <mat-icon>create</mat-icon>
                      </a>
                      <a mat-icon-button color="primary" *ngIf="!element.editable && !esAdminSSO" aria-label="Editar" [routerLink]="['/hipos', element.idHipo]">
                        <!-- (click)="openDialog(element)" -->
                        <mat-icon>search</mat-icon>
                      </a>
                      <button type="button" *ngIf="esAdminSSO" 
                      (click)="deleteHipo(element)" mat-icon-button color="primary" aria-label="Eliminar">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </td>
                  </ng-container>
        
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            
              </table>  
      
            <mat-paginator #paginator [length]="resultsLength" [pageSize]="30" 
                  (page)="getPaginatorData($event)"
                  [pageSizeOptions]="[30, 50, 100]"></mat-paginator>
          </div>
      </div>
    </div>
</div>